function a(a, r, t) {
  null == r && (r = a || 0, a = 0), t || (t = r < a ? -1 : 1);
  for (var e = Math.max(Math.ceil((r - a) / t), 0), n = Array(e), l = 0; l < e; l++, a += t) n[l] = a;
  return n;
}
export { a as default };